import { TCommercialOrganization } from '@app/services/filter-service/response-interfaces/get-co.response';
import { NegotiationRoomApi } from '@app/services/negotiation-room-service/negotiation-room.service';
import { selectSelectedCo } from '@app/store/filters-module/co';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put, select } from 'redux-saga/effects';
import {
  createExceptionNegotiationAction,
  fetchExceptionsNegotiationDataAction,
  setIsOpenModalAction,
} from '..';

export function* createExceptionsSaga(
  action: ReturnType<typeof createExceptionNegotiationAction>
) {
  try {
    const selectedCO: TCommercialOrganization = yield select(selectSelectedCo);
    yield call(NegotiationRoomApi.createExceptions, action.data, selectedCO.id);
    yield put(setIsOpenModalAction({ isOpen: false }));
    yield put(fetchExceptionsNegotiationDataAction({}));
  } catch (e) {
    yield put(setIsOpenModalAction({ isOpen: true }));
    console.log('Failed to get exceptions items', e.message);
    if (
      e.response &&
      (e.response.status === 409 || e.response.status === 400)
    ) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'save exception',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'save exception',
        },
      })
    );
  }
}
